import React, { useEffect, useState } from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import ReactShowMoreText from "react-show-more-text";
import Slider from "react-slick";
import { IoMdArrowRoundBack, IoMdArrowRoundForward } from "react-icons/io";
import { getCookie } from "../../helpers/CookieComponent";
import { apiHeader, postData } from "../../helpers/ApiHelper";
import { IoClose } from "react-icons/io5";
import BookPdf from "./BookPdf";

const MyLibraryDetail = () => {
  ChangeTitle("My Library Detail");
  const bookId = getCookie("libraryId");
  const libraryCurrency = getCookie("l-currency");
  const [booksDetails, setBooksDetails] = useState({});
  const [isBookModalOpen, setIsBookModalOpen] = useState(false);

  // Opem Modal Popup Form Function
  const openModal = () => {
    document.body.style.overflowY = "hidden";
    setIsBookModalOpen(true);
  };

  // Close Modal Popup Form Function
  const closeModal = () => {
    document.body.style.overflowY = "";
    setIsBookModalOpen(false);
  };

  // Book List API Call
  const viewBookDetail = async (bookId) => {
    const param = {
      bookId: bookId,
    };

    console.log(param);

    var response = await postData(
      "private/user/mylibrary/detail",
      param,
      apiHeader(false)
    );

    console.log(response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setBooksDetails(data);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    viewBookDetail(bookId);
  }, [bookId]);

  const productDetails = [
    {
      src: toAbsoluteUrl("media/img/icon/basic/user.svg"),
      title1: "Publisher",
      title2: booksDetails && booksDetails.publisher && booksDetails.publisher,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/calendar.svg"),
      title1: "Date of publication",
      title2:
        booksDetails &&
        booksDetails.dateOfPublication &&
        booksDetails.dateOfPublication,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/calendar.svg"),
      title1: "Expiry Date",
      title2:
        booksDetails &&
        booksDetails.validTill &&
        booksDetails.validTill,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/star.svg"),
      title1: "Edition",
      title2: booksDetails && booksDetails.edition && booksDetails.edition,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/keyboard.svg"),
      title1: "ISBN",
      title2: booksDetails && booksDetails.isbnNo && booksDetails.isbnNo,
    },
    {
      src: toAbsoluteUrl("media/img/icon/basic/slider-horizontal.svg"),
      title1: "No. of page",
      title2: booksDetails && booksDetails.noOfPages && booksDetails.noOfPages,
    },
  ];

  const settings = {
    slidesPerRow: 1,
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: true,
    swipeToSlide: true,
    arrows: true,
    nextArrow: (
      <div>
        <div className="relative top-[-3rem] left-[-4rem] xs:left-[-4.5rem] md:left-[-4rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] w-max shadow-lg main-arrow main-arrow2">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundForward className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    prevArrow: (
      <div>
        <div className="relative top-[-3rem] p-[1rem] xs:p-[1.5rem] md:p-[1rem] xl:p-[1.5rem] left-[1rem] xs:left-0 w-max shadow-lg main-arrow">
          <div className="ma-part p-[.5rem] xs:p-[1rem] md:p-[.5rem] xl:p-[1rem]">
            <IoMdArrowRoundBack className="text-4xl arrow" />
          </div>
        </div>
      </div>
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      {isBookModalOpen == true && (
        <>
          <div
            onClick={closeModal}
            className={`w-full fixed top-0 z-[9999] h-screen overflow-x-hidden overflow-y-auto bg-form getintouch`}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="w-max xxl:container p-[2%] mx-auto my-[20%] md:my-[10%] lg:my-[5rem] relative xxl:top-1/2 transform xxl:-translate-y-1/2 form-box"
            >
              <div className="mb-[3%] flex items-center justify-between">
                <h1 className="hanson">{booksDetails.title}</h1>
                <IoClose
                  onClick={closeModal}
                  className="w-[3rem] h-[3rem] cursor-pointer"
                />
              </div>
              <div className="flex justify-center">
                {booksDetails?.content && (
                  <BookPdf pdf={booksDetails?.content} />
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="w-full lg:w-[90%] xxl:container mx-auto">
          <div className="w-full flex flex-col lg:flex-row mb-[5%] gap-10 sec-bd">
            <div className="w-[30%] h-[35vw] p-4 sbd-part1 sld-img-box">
              <img
                className="w-full h-full object-cover"
                src={
                  booksDetails &&
                  booksDetails.bookImage &&
                  booksDetails.bookImage
                }
                alt=""
              />
            </div>
            <div className="lg:w-[65%] sbd-part2">
              <h1 className="w-full mb-[1%] sbdp2-title">
                {booksDetails && booksDetails.title && booksDetails.title}
              </h1>
              <h1 className="w-full mb-[1%] sld-para ">
                {booksDetails && booksDetails.price && booksDetails.price}{" "}
                {libraryCurrency && libraryCurrency}
              </h1>
              <div className="w-full mb-[5%] flex gap-5 sbdp2-btns">
                {/* <a
                  href={
                    booksDetails && booksDetails.content && booksDetails.content
                  }
                  target="_blank"
                  className="w-max py-[2%] px-[5%] rounded-none sbdp2-btn"
                >
                  View content
                </a> */}
                <button
                  onClick={openModal}
                  className="w-max py-[2%] px-[5%] rounded-none sbdp2-btn"
                >
                  View content
                </button>
                {/* <a
                  href={
                    booksDetails &&
                    booksDetails.sampleChapter &&
                    booksDetails.sampleChapter
                  }
                  target="_blank"
                  className="w-max py-[2%] px-[5%] rounded-none sbdp2-btn"
                >
                  Sample Chapter
                </a> */}
              </div>
              <div className="w-full mb-[5%] relative sbdp2-product-details sbdp2pd">
                <h1 className="mb-[5%] sbdp2pd-title">Product details</h1>
                <div className="w-[75%] sm:w-[80%] lg:w-[90%] lg:ml-[1%] xl:ml-[2%] md:w-full mx-auto">
                  <Slider
                    className="w-full h-max lg:w-[88%] xl:w-[98%] mx-auto cursor-pointer"
                    {...settings}
                  >
                    {productDetails.map((data, i) => (
                      <>
                        <div className="flex flex-col items-center sbdp2pd-box">
                          <img
                            className="mb-[5%] sbdp2pdb-icon"
                            src={data.src}
                            alt=""
                          />
                          <h1 className="text-center sbdp2pdb-title1">
                            {data.title1}
                          </h1>
                          <h1 className="text-center sbdp2pdb-title2">
                            {data.title2}
                          </h1>
                        </div>
                      </>
                    ))}
                  </Slider>
                </div>
              </div>
              <div className="sbdp2-description sbdp2d">
                <h1 className="mb-[1%] sbdp2d-title">Description</h1>
                <p className="mb-[2%] sbdp2d-p">
                  <ReactShowMoreText
                    lines={5}
                    more="View More"
                    less="View Less"
                    className=""
                    expanded={false}
                  >
                    {booksDetails &&
                      booksDetails.description &&
                      booksDetails.description}
                  </ReactShowMoreText>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyLibraryDetail;
